import { LocalstorageService } from 'src/app/services/localstorage.service';
import { AuthService } from './../services/auth.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    userToken: string = "";
    // create refresh token variable on 27022023
    userRefreshToken: string = "";
    constructor(private _authService: AuthService,
        private _localStorage: LocalstorageService,
        private spinner: NgxSpinnerService,
        private router: Router) {
        if (this.userToken == '') {
            if (this._localStorage.getCookie('token')) {
                this.userToken = this._localStorage.getCookie('token')
            }
        }
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //check if token needs to be attached
        // console.log('line no. 29', request.url);
        if (request.url.indexOf('execute-api.ap-south-1.amazonaws') >= 0) {
            //check if token is stored already
            if (request.url.indexOf('/signup') >= 0
                || request.url.indexOf('/refresh-token') >= 0
                || request.url.indexOf('/login') >= 0
                || request.url.indexOf('/logout') >= 0
                || request.url.indexOf('/poc-login') >= 0
                || request.url.indexOf('/login/admin') >= 0
                || request.url.indexOf('/notification/password') >= 0
                || request.url.indexOf('/countries-states-cities') >= 0
                || request.url.indexOf('/payments/others') >= 0
                || request.url.indexOf('entity?name') >= 0
            ) {
                return next.handle(request);
            }

            let userJwtToken = localStorage.getItem('token');
            if (userJwtToken) {
                request = request.clone({
                    setHeaders: {
                        "Content-Type": 'application/json',
                        "Authorization": userJwtToken
                    }
                });

                return next.handle(request).pipe(
                    catchError((errorData) => {
                        console.log("line no. 43 request status", errorData.status);
                        console.log("line no. 44 request status", request.url);
                    
                        return throwError(errorData);
                    })
                );
            }

        }
        else {
            return next.handle(request);
        }


    }

    // reload current route when the token has been expired 22032023
    reloadCurrentRoute() {

        let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);

    }
}
